import React from 'react';
import { Tag, Filter, Play, FileText } from 'lucide-react';
import { Button } from '../../components/ui/button';
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem,
    DropdownMenuTrigger, DropdownMenuSeparator,
} from '../../components/ui/dropdown-menu';

// ─── FiltersBar ────────────────────────────────────────────────────
// Desktop-only Tags + Content-Type filter dropdowns that sit inline
// with the search bar. Both dropdowns update the parent's active
// filter state via the setters passed in; when a filter is active,
// the trigger button label shows the chosen value instead of the
// default word ("Tags" / "Type").
export function FiltersBar({
    tags,
    selectedTag,
    setSelectedTag,
    selectedType,
    setSelectedType,
}) {
    return (
        <div className="hidden sm:flex gap-2">
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button variant="outline" className="rounded-xl px-3 h-10 text-sm border-border" data-testid="tag-filter-btn">
                        <Tag className="w-4 h-4 mr-1.5" />
                        {selectedTag || 'Tags'}
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-48">
                    <DropdownMenuItem onClick={() => setSelectedTag(null)}>All Tags</DropdownMenuItem>
                    <DropdownMenuSeparator />
                    {tags.map(({ tag, count }) => (
                        <DropdownMenuItem key={tag} onClick={() => setSelectedTag(tag)}>
                            {tag} <span className="ml-auto text-muted-foreground text-xs">{count}</span>
                        </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
            </DropdownMenu>

            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button variant="outline" className="rounded-xl px-3 h-10 text-sm border-border" data-testid="type-filter-btn">
                        <Filter className="w-4 h-4 mr-1.5" />
                        {selectedType || 'Type'}
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                    <DropdownMenuItem onClick={() => setSelectedType(null)}>All Types</DropdownMenuItem>
                    <DropdownMenuSeparator />
                    <DropdownMenuItem onClick={() => setSelectedType('video')}>
                        <Play className="w-4 h-4 mr-2" /> Video
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => setSelectedType('text')}>
                        <FileText className="w-4 h-4 mr-2" /> Text
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}
